import {
  Box,
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  Text,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { currency, percent } from "@src/utils/formatters";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC } from "react";

/**
 * All numbers must be in denominated(raw) value
 */
interface TooltipComplexOurWorkProps {
  timeTracking: {
    percent: number;
    value: number;
    time: number;
  };

  progress: {
    percent: number;
    value: number;
    time: number;
  };
}

/**
 * @children Wrap with PopoverTrigger
 */
export const TooltipComplexOurWork: FC<
  React.PropsWithChildren<TooltipComplexOurWorkProps>
> = ({ children, timeTracking, progress }) => {
  const { workspaceStore } = useStore();

  return (
    <Popover trigger="hover">
      {children}
      <PopoverContent>
        <PopoverBody color="whiteAlpha.900" bg="gray.700" borderRadius="4">
          <Flex minW="200px" fontSize="sm">
            <Box w="60%" pr="2" textAlign="start">
              <Text mb="0.5" fontWeight="semibold">
                <Trans>Time tracking</Trans>:
              </Text>
              <Text mb="0.5">{percent.format(timeTracking.percent)}</Text>
              <Text mb="0.5">
                {currency.formatByWorkspace(timeTracking.value)}
              </Text>
              <Text mb="0.5">
                {workspaceStore.settings?.timeTrackingRateValueReadable(
                  timeTracking.time,
                )}
              </Text>
            </Box>

            <Box alignItems="start" w="40%" textAlign="start">
              <Text mb="0.5" fontWeight="semibold">
                <Trans>Progress</Trans>:
              </Text>
              <Text mb="0.5">{percent.format(progress.percent)}</Text>
              <Text mb="0.5">{currency.formatByWorkspace(progress.value)}</Text>
              <Text mb="0.5">
                {workspaceStore.settings?.timeTrackingRateValueReadable(
                  progress.time,
                )}
              </Text>
            </Box>
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default observer(TooltipComplexOurWork);
